import {Component, OnInit} from '@angular/core';
import {FormBuilder, Validators, FormGroup, FormControl} from "@angular/forms";
import {CashBookingService} from "../../../services/cash-booking.service";
import {AuthenticationService, AlertService, LoaderService, SettingsService} from "../../../services/index";
import {ActivatedRoute, Params, Router} from "@angular/router";
declare var $:any;
import * as moment from 'moment';
import 'bootstrap';
import {LocationList} from '../../../models/location';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';

@Component({
  selector: 'app-cash-book',
  templateUrl: './cash-book.component.html',
  styleUrls: ['./cash-book.component.css']
})


export class CashBookComponent implements OnInit {
  private moneyRegex = '^([0-9]+|[0-9]*(\.[0-9])([0-9])?)$';
  private cashBookForm;
  private consignmentList;
  private cashBookFormObject;
  private settingsList;
  private selectedSettingsList;
  private loading = false;
  private id;
  private locations;
  private senderCountryList = [];
  private senderStatesList = [];
  private senderCityList = [];
  private receiverCountryList = [];
  private receiverStatesList = [];
  private receiverCityList = [];
  private printId;
  private netAmountChanged = false;
  private firmDetails;

  constructor(private formBuilder:FormBuilder,
              private cashBookingService:CashBookingService,
              private authenticationService:AuthenticationService,
              private alertService:AlertService,
              private settingsService:SettingsService,
              private loaderService:LoaderService,
              private router:Router,
              private route:ActivatedRoute) {
  }

  ngOnInit() {
    this.locations = LocationList;
    this.route.queryParams.forEach((params:Params) => {
      this.id = params['id'];
      this.printId = this.id;
    });
    this.locations = LocationList;
    this.senderCityList = [].concat.apply([], this.locations.map(l=>l.city));
    this.receiverCityList = [].concat.apply([], this.locations.map(l=>l.city));

    this.id ? this.loaderService.loading(true) : null;
    this.cashBookForm = this.formBuilder.group({
        consignment_number: ['', Validators.required],
        consignment_type: ['Document', Validators.required],
        date: [''],
        booking_date: ['', Validators.required],
        center: ['', Validators.required],
        sender_gstin: [''],
        sender_mobile_number: ['', Validators.pattern('^([0|\+[0-9]{1,5})?([7-9][0-9]{9})$')],
        sender_name: ['', Validators.required],
        sender_address: [''],
        sender_country: ['', Validators.required],
        sender_state: ['', Validators.required],
        sender_city: ['', Validators.required],
        sender_email: [''],
        receiver_gstin: [''],
        receiver_mobile_number: ['', Validators.pattern('^([0|\+[0-9]{1,5})?([7-9][0-9]{9})$')],
        receiver_name: ['', Validators.required],
        receiver_address: ['', Validators.required],
        receiver_country: ['', Validators.required],
        receiver_state: ['', Validators.required],
        receiver_city: ['', Validators.required],
        receiver_email: [''],
        remark: [''],
        description: [''],
        courier_company: ['', Validators.required],
        weight: ['', [Validators.pattern(this.moneyRegex), Validators.required]],
        weight_charges: ['', [Validators.pattern(this.moneyRegex), Validators.required]],
        length: ['', Validators.pattern(this.moneyRegex)],
        width: ['', Validators.pattern(this.moneyRegex)],
        height: ['', Validators.pattern(this.moneyRegex)],
        valuation: [''],
        valuation_charge: [''],
        insured: [''],
        insurance_charge: ['', Validators.pattern(this.moneyRegex)],
        pod: [''],
        pod_charge: ['', Validators.pattern(this.moneyRegex)],
        igst_rate: [''],
        igst_amount: ['', Validators.pattern(this.moneyRegex)],
        cgst_rate: [''],
        cgst_amount: ['', Validators.pattern(this.moneyRegex)],
        sgst_rate: [''],
        sgst_amount: ['', Validators.pattern(this.moneyRegex)],
        net_amount: ['', Validators.pattern(this.moneyRegex)],
        total_charge: ['', Validators.pattern(this.moneyRegex)]
      }
    );
    $('#date').datetimepicker({
      format: 'DD/MM/YYYY'
    });

    $('#date').on('dp.change', (ev) => {
      this.cashBookForm.patchValue({
        booking_date: new Date(ev.date.toDate()).getTime()
      });
    });
    $('#date').on('blur', (ev) => {
      !(<HTMLInputElement>ev.currentTarget).value ? this.cashBookForm.patchValue({booking_date: null}) : null;
    });

    !this.id ? this.getSettingsData() : null;
    !this.id ? this.getNewConsignmentId() : null;
    this.getConsignmentData();
    this.getFirmData();
    this.id ? this.cashBookingService.getById(this.id).subscribe(
      data => {
        this.cashBookFormObject = data[0] || {};
        $('#date').data("DateTimePicker").date(moment(new Date(data[0].booking_date)).format('DD/MM/YYYY'));
        this.cashBookForm.patchValue(data[0]);
        this.getSettingsData();

        setTimeout(()=> {
            data[0].sender_city ? this.cashBookForm.patchValue({sender_city: data[0].sender_city}) : null;
            data[0].receiver_city ? this.cashBookForm.patchValue({receiver_city: data[0].receiver_city}) : null;
            this.loaderService.loading(false);
          }
          , 800);
      },
      error => {
        this.alertService.error(error);
        this.loading = false;
        this.loaderService.loading(false);
      }) : this.cashBookFormObject = {};

    this.cashBookForm.controls['sender_country'].valueChanges.subscribe(value => {
      this.weightChanged();
      this.netAmountChanged = false;
    });
    this.cashBookForm.controls['sender_state'].valueChanges.subscribe(value => {
      this.weightChanged();
      this.netAmountChanged = false;
    });
    this.cashBookForm.controls['sender_city'].valueChanges.subscribe(value => {
      var locationDetails = this.locations.find(location=>location.city.indexOf(value) > -1) || {
          country: '',
          state: ''
        };
      locationDetails ? this.cashBookForm.patchValue({
        sender_country: locationDetails.country,
        sender_state: locationDetails.state
      }) : null;
      this.weightChanged();
      this.netAmountChanged = false;
    });
    this.cashBookForm.controls['receiver_country'].valueChanges.subscribe(value => {
      this.weightChanged();
      this.netAmountChanged = false;
    });
    this.cashBookForm.controls['receiver_state'].valueChanges.subscribe(value => {
      this.weightChanged();
      this.netAmountChanged = false;
    });
    this.cashBookForm.controls['receiver_city'].valueChanges.subscribe(value => {
      var locationDetails = this.locations.find(location=>location.city.indexOf(value) > -1) || {
          country: '',
          state: ''
        };
      locationDetails ? this.cashBookForm.patchValue({
        receiver_country: locationDetails.country,
        receiver_state: locationDetails.state
      }) : null;
      this.weightChanged();
      this.netAmountChanged = false;
    });
    this.cashBookForm.controls['net_amount'].valueChanges.subscribe(value => {
      this.netAmountChanged ? this._netAmountChanged(value) : null;
    });
    this.cashBookForm.controls['weight'].valueChanges.subscribe(value => {
      !this.netAmountChanged ? this.weightChanged() : null;
    });
    this.cashBookForm.controls['length'].valueChanges.subscribe(value => {
      this.volumeUnitChanged();
    });
    this.cashBookForm.controls['width'].valueChanges.subscribe(value => {
      this.volumeUnitChanged();
    });
    this.cashBookForm.controls['height'].valueChanges.subscribe(value => {
      this.volumeUnitChanged();
    });
    this.cashBookForm.controls['igst_rate'].valueChanges.subscribe(value => {
      !this.netAmountChanged ? this.chargesChanged() : null;
    });
    this.cashBookForm.controls['sgst_rate'].valueChanges.subscribe(value => {
      !this.netAmountChanged ? this.chargesChanged() : null;
    });
    this.cashBookForm.controls['cgst_rate'].valueChanges.subscribe(value => {
      !this.netAmountChanged ? this.chargesChanged() : null;
    });
    this.cashBookForm.controls['weight_charges'].valueChanges.subscribe(value => {
      !this.netAmountChanged ? this.chargesChanged() : null;
    });
    this.cashBookForm.controls['pod_charge'].valueChanges.subscribe(value => {
      !this.netAmountChanged ? this.chargesChanged() : null;
    });
    this.cashBookForm.controls['valuation_charge'].valueChanges.subscribe(value => {
      !this.netAmountChanged ? this.chargesChanged() : null;
    });
    this.cashBookForm.controls['insurance_charge'].valueChanges.subscribe(value => {
      !this.netAmountChanged ? this.chargesChanged() : null;
    });
    !this.id ? this.cashBookForm.patchValue({sender_country: 'India', receiver_country: 'India'}) : null;
    !this.id ? this.cashBookForm.patchValue({sender_state: 'Gujarat', receiver_state: 'Gujarat'}) : null;
  }

  getFirmData() {
    this.loading = true;
    this.settingsService.firmDetails().subscribe(
      data => {
        data.length ? this.firmDetails = data[0] : null;
        this.loading = false;
        this.loaderService.loading(false);
      },
      error => {
        this.alertService.error(error);
        this.loading = false;
        this.loaderService.loading(false);
      });
  }

  _netAmountChanged(netAmount) {
    var total = 0;
    netAmount = parseInt(netAmount);
    if (netAmount && this.cashBookForm.controls.receiver_state.value && this.cashBookForm.controls.receiver_country.value && this.firmDetails) {

      total = this.cashBookForm.controls.receiver_country.value.toLowerCase() != "india" ? netAmount :
        this.cashBookForm.controls.receiver_state.value.toLowerCase() != this.firmDetails.state.toLowerCase() ?
          ((netAmount * 100) / (parseFloat(this.cashBookForm.controls.igst_rate.value) + 100))
          : ((netAmount * 100) / ((parseFloat(this.cashBookForm.controls.cgst_rate.value) + parseFloat(this.cashBookForm.controls.sgst_rate.value)) + 100));

      total = parseFloat(total.toFixed(2));
      this.cashBookForm.patchValue({total_charge: total});

      this.cashBookForm.controls.valuation_charge.value && this.cashBookForm.controls.valuation_charge.valid ? total -= parseFloat(this.cashBookForm.controls.valuation_charge.value) : null;
      this.cashBookForm.controls.pod_charge.value && this.cashBookForm.controls.pod_charge.valid ? total -= parseFloat(this.cashBookForm.controls.pod_charge.value) : null;
      this.cashBookForm.controls.insurance_charge.value && this.cashBookForm.controls.insurance_charge.valid ? total -= parseFloat(this.cashBookForm.controls.insurance_charge.value) : null;
      total = parseFloat(total.toFixed(2));
      this.cashBookForm.patchValue({weight_charges: total});
      this.cashBookForm.controls.receiver_country.value.toLowerCase() != 'india' ? (
        this.cashBookForm.patchValue({igst_amount: ''}),
          this.cashBookForm.patchValue({cgst_amount: ''}),
          this.cashBookForm.patchValue({sgst_amount: ''})) :
        this.cashBookForm.controls.receiver_state.value.toLowerCase() != this.firmDetails.state.toLowerCase() ?
          (this.cashBookForm.controls.igst_rate.value && this.cashBookForm.controls.igst_rate.valid ? this.cashBookForm.patchValue({igst_amount: parseFloat(((total * this.cashBookForm.controls.igst_rate.value) / 100).toFixed(2))}) : this.cashBookForm.patchValue({igst_amount: ''}),
            this.cashBookForm.patchValue({cgst_amount: ''}),
            this.cashBookForm.patchValue({sgst_amount: ''}))
          : (this.cashBookForm.patchValue({igst_amount: ''}), this.cashBookForm.controls.cgst_rate.value && this.cashBookForm.controls.cgst_rate.valid ? this.cashBookForm.patchValue({cgst_amount: parseFloat(((total * this.cashBookForm.controls.cgst_rate.value) / 100).toFixed(2))}) : this.cashBookForm.patchValue({cgst_amount: ''}),
          this.cashBookForm.controls.sgst_rate.value && this.cashBookForm.controls.sgst_rate.valid ? this.cashBookForm.patchValue({sgst_amount: parseFloat(((total * this.cashBookForm.controls.sgst_rate.value) / 100).toFixed(2))}) : this.cashBookForm.patchValue({sgst_amount: ''}));
    }
  }

  netAmountFocused() {
    this.netAmountChanged = true;
  }

  netAmountBlured() {
    this.netAmountChanged = false;
  }

  printBooking($event) {
    $('#printWarningModal').modal('hide');
    this.router.navigate(['/cash_booking_print'], {queryParams: {id: this.printId, type: 'cashBooking'}});
  }

  formatter = (result:string) => `${result} (${this.locations.find(location=>location.city.indexOf(result) > -1).state})`;

  searchSenderCountry = (text$:Observable<string>) =>
    text$
      .debounceTime(200)
      .distinctUntilChanged()
      .map(term => term.length < 1 ? []
        : this.senderCountryList.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10));

  searchSenderState = (text$:Observable<string>) =>
    text$
      .debounceTime(200)
      .distinctUntilChanged()
      .map(term => term.length < 1 ? []
        : this.senderStatesList.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10));

  searchSenderCity = (text$:Observable<string>) =>
    text$
      .debounceTime(200)
      .distinctUntilChanged()
      .map(term => term.length < 3 ? [] : this.senderCityList.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1));

  searchReceiverCountry = (text$:Observable<string>) =>
    text$
      .debounceTime(200)
      .distinctUntilChanged()
      .map(term => term.length < 1 ? []
        : this.receiverCountryList.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10));

  searchReceiverState = (text$:Observable<string>) =>
    text$
      .debounceTime(200)
      .distinctUntilChanged()
      .map(term => term.length < 1 ? []
        : this.receiverStatesList.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10));

  searchReceiverCity = (text$:Observable<string>) =>
    text$
      .debounceTime(200)
      .distinctUntilChanged()
      .map(term => term.length < 3 ? [] : this.receiverCityList.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1));

  getNewConsignmentId() {
    this.loaderService.loading(true);
    this.settingsService
      .consignmentNumber()
      .subscribe(
        data => {
          this.cashBookForm.patchValue(data);
          this.loaderService.loading(false);
        },
        error => {
          this.alertService.error(error);
          this.loaderService.loading(false);
        });
  }

  getConsignmentData() {
    this.settingsService.consignmentList().subscribe(
      data => {
        this.consignmentList = data || [];
        this.loaderService.loading(false);
      },
      error => {
        this.alertService.error(error);
        this.loaderService.loading(false);
      });
  }

  getSettingsData() {
    this.settingsService.getSettings().subscribe(
      data => {
        this.settingsList = data || [];
        !this.id ? this.onConsignmentTypeChange() : this.selectedSettingsList = this.settingsList.find(s=>s.consignment_type == this.cashBookForm.controls['consignment_type'].value);
        this.loaderService.loading(false);
      },
      error => {
        this.alertService.error(error);
        this.loading = false;
        this.loaderService.loading(false);
      });
  }

  onConsignmentTypeChange() {
    this.selectedSettingsList = this.settingsList.find(s=>s.consignment_type == this.cashBookForm.controls['consignment_type'].value);
    var data = this.selectedSettingsList ? {
      igst_rate: this.selectedSettingsList.igst_rate,
      cgst_rate: this.selectedSettingsList.cgst_rate,
      sgst_rate: this.selectedSettingsList.sgst_rate,
    } : {
      igst_rate: '',
      cgst_rate: '',
      sgst_rate: ''
    };
    data ? this.cashBookForm.patchValue(data) : null;
    this.weightChanged();
    this.volumeUnitChanged();
  }

  volumeUnitChanged() {
    var weight = ((this.cashBookForm.controls.length.value && this.cashBookForm.controls.length.valid ? parseFloat(this.cashBookForm.controls.length.value) : 0)
      * (this.cashBookForm.controls.width.value && this.cashBookForm.controls.width.valid ? parseFloat(this.cashBookForm.controls.width.value) : 0)
      * (this.cashBookForm.controls.height.value && this.cashBookForm.controls.height.valid ? parseFloat(this.cashBookForm.controls.height.value) : 0)) / 5;
    this.selectedSettingsList ? this.cashBookForm.patchValue({weight: weight || 0}) : null;
  }

  weightChanged() {
    this.selectedSettingsList ? this.cashBookForm.patchValue({weight_charges: this.getAppropriateWeightRangeRateFromArray(parseFloat(this.cashBookForm.controls.weight.value) || 0)}) : 0;
  }

  getAppropriateWeightRangeRateFromArray(weight:number) {
    console.log("--------------------")
    console.log(weight)
    var charge:number = 0;
    var thousandPlus:number = 0;
    weight > 1000 ? ((thousandPlus = (parseInt((weight / 1000).toFixed(0)) - (weight % 1000 == 0 ? 1 : 0))), weight = 1000) : null;
    if (this.firmDetails && this.cashBookForm.controls.receiver_country.value && this.cashBookForm.controls.receiver_state.value && this.cashBookForm.controls.receiver_city.value) {
      var rate = this.cashBookForm.controls.receiver_country.value.toLowerCase() != 'india' ?
        "weight_range_rate_roi"
        : this.cashBookForm.controls.receiver_state.value.toLowerCase() == this.firmDetails.state.toLowerCase() ?
        this.cashBookForm.controls.receiver_city.value.toLowerCase() == this.firmDetails.city.toLowerCase() ?
          "weight_range_rate" : "weight_range_rate_cross"
        : this.cashBookForm.controls.receiver_city.value.toLowerCase() == "mumbai" ?
        "weight_range_rate_mumbai" : "weight_range_rate_roi";

      console.log(rate)
      console.log(this.selectedSettingsList[rate].find(rate=>rate.start <= weight && rate.end >= weight))

      charge = parseFloat(this.selectedSettingsList[rate].find(rate=>rate.start <= weight && rate.end >= weight).amount);
      thousandPlus ? charge += parseFloat(this.selectedSettingsList[rate].find(rate=>rate.end == '+').amount) * thousandPlus : null;
    }
    console.log(charge)
    return charge;
  }

  chargesChanged():void {
    var total = 0;
    if (this.cashBookForm.controls.receiver_state.value && this.cashBookForm.controls.receiver_country.value && this.firmDetails) {
      this.cashBookForm.controls.weight_charges.value && this.cashBookForm.controls.weight_charges.valid ? total += parseFloat(this.cashBookForm.controls.weight_charges.value) : null;
      this.cashBookForm.controls.valuation_charge.value && this.cashBookForm.controls.valuation_charge.valid ? total += parseFloat(this.cashBookForm.controls.valuation_charge.value) : null;
      this.cashBookForm.controls.pod_charge.value && this.cashBookForm.controls.pod_charge.valid ? total += parseFloat(this.cashBookForm.controls.pod_charge.value) : null;
      this.cashBookForm.controls.insurance_charge.value && this.cashBookForm.controls.insurance_charge.valid ? total += parseFloat(this.cashBookForm.controls.insurance_charge.value) : null;
      total = parseFloat(total.toFixed(2));
      this.cashBookForm.patchValue({total_charge: total});
      this.cashBookForm.controls.receiver_country.value.toLowerCase() != 'india' ? (
        this.cashBookForm.patchValue({igst_amount: ''}),
          this.cashBookForm.patchValue({cgst_amount: ''}),
          this.cashBookForm.patchValue({sgst_amount: ''})) :
        this.cashBookForm.controls.receiver_state.value.toLowerCase() != this.firmDetails.state.toLowerCase() ?
          (this.cashBookForm.controls.igst_rate.value && this.cashBookForm.controls.igst_rate.valid ? this.cashBookForm.patchValue({igst_amount: parseFloat(((total * this.cashBookForm.controls.igst_rate.value) / 100).toFixed(2))}) : this.cashBookForm.patchValue({igst_amount: ''}),
            this.cashBookForm.patchValue({cgst_amount: ''}),
            this.cashBookForm.patchValue({sgst_amount: ''}))
          :
          (this.cashBookForm.patchValue({igst_amount: ''}), this.cashBookForm.controls.cgst_rate.value && this.cashBookForm.controls.cgst_rate.valid ? this.cashBookForm.patchValue({cgst_amount: parseFloat(((total * this.cashBookForm.controls.cgst_rate.value) / 100).toFixed(2))}) : this.cashBookForm.patchValue({cgst_amount: ''}),
            this.cashBookForm.controls.sgst_rate.value && this.cashBookForm.controls.sgst_rate.valid ? this.cashBookForm.patchValue({sgst_amount: parseFloat(((total * this.cashBookForm.controls.sgst_rate.value) / 100).toFixed(2))}) : this.cashBookForm.patchValue({sgst_amount: ''}));
      this.cashBookForm.patchValue({net_amount: parseFloat((total + (this.cashBookForm.controls.receiver_state.value.toLowerCase() != this.firmDetails.state.toLowerCase() ? (this.cashBookForm.controls.igst_amount.value || 0) : ((this.cashBookForm.controls.cgst_amount.value || 0) + (this.cashBookForm.controls.sgst_amount.value || 0)))).toFixed(2))});
    }
    else {
      this.cashBookForm.patchValue({cgst_amount: ''});
      this.cashBookForm.patchValue({sgst_amount: ''});
      this.cashBookForm.patchValue({igst_amount: ''});
      this.cashBookForm.patchValue({total_charge: 0});
      this.cashBookForm.patchValue({net_amount: 0});
    }
  }

  validateAllFormFields(formGroup:FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({onlySelf: true});
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
    $(document).ready(function () {
      $('html, body').animate({
        scrollTop: $('.alert-danger').closest('.form-group').offset().top - 56
      }, 500);
    });
  }

  submitCashBooking() {
    // Object.keys(this.cashBookForm.controls).forEach((k)=> {
    //   console.log(k, ' = ', this.cashBookForm.controls[k].value, ' - ', this.cashBookForm.controls[k].valid);
    // });
    this.cashBookForm.valid ? this.createNewCashBooking() : this.validateAllFormFields(this.cashBookForm);
  }

  createNewCashBooking() {
    this.loading = true;
    var value = this.cashBookForm.value;
    !this.cashBookFormObject._id ? value['created_by'] = this.authenticationService.user()._id : null;
    this.cashBookFormObject._id ? this.cashBookingService.putById(this.cashBookFormObject._id, value)
      .subscribe(
        data => {
          this.alertService.success('Cash Book Updated...', true);
          this.cashBookForm.reset();
          this.cashBookFormObject = {};
          this.router.navigate(['/cash_booking_list']);
        },
        error => {
          this.alertService.error(error);
          this.loading = false;
        })
      : this.cashBookingService.create(value)
      .subscribe(
        data => {
          this.alertService.success('Cash Book Generated...', true);
          this.cashBookForm.reset();
          this.cashBookForm.patchValue({sender_country: 'India', receiver_country: 'India'});
          this.cashBookForm.patchValue({sender_state: 'Gujarat', receiver_state: 'Gujarat'});
          this.getNewConsignmentId();
          this.loading = false;
          this.printId = data._id;
          $('#printWarningModal').modal('show');
        },
        error => {
          var message = error._body ? JSON.parse(error._body).message : null;
          this.alertService.error(message || error);
          this.loading = false;
        });
  }
}



// WEBPACK FOOTER //
// /root/production/sne-pro/src/app/component/cash-book/create/cash-book.component.ts